module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ftit"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Money")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Twelve pennies (written d for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("denarii")]), _vm._v(") made one shilling (s), and 20 shillings made one pound (£ or l for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("librae")]), _vm._v("), i.e. 240d. Another unit of accounting was the mark, which was two-thirds of a pound and consisted of 160d or 13s and 4d. In the fourteenth century, a labourer typically earned 2d a day or £3 a year, and a master craftsman 6d a day.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c5c0278","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Money.vue
// module id = 72
// module chunks = 0